import ApiService from "@/common/api.service"

export const DashboardService = {
    async getOverview(query) {
        const queryParam = query ? `/dashboard/overview${query}` : `/dashboard/overview`;
        const res = await ApiService.get(queryParam);
        return res.data;
    },
    async getCpdProvDash() {
        const res = await ApiService.get("/dashboard/cpdProvider");
        return res.data
    },
    async getCourseDash() {
        const res = await ApiService.get("/dashboard/course");
        return res.data
    },
    async getAccreditorDash() {
        const res = await ApiService.get("/dashboard/accreditor");
        return res.data
    },
    async getCpdActivityDash() {
        const res = await ApiService.get("/dashboard/cpdActivity");
        return res.data
    },
    async getTraineeOneDash() {
        const res = await ApiService.get("/dashboard/cateogory1Trainee");
        return res.data
    },
    async getTraineeTwoDash() {
        const res = await ApiService.get("/dashboard/cateogory2Trainee");
        return res.data
    },
    async getAccreditorAggDash(query) {
        let queryParam = query ? `/dashboard/accreditorAgg${query}`
            : `/dashboard/accreditorAgg`;
        const res = await ApiService.get(queryParam);
        return res.data
    },
    async getCpdProvAggDash(query) {
        let queryParam = query ? `/dashboard/cpdProviderAgg${query}`
            : `/dashboard/cpdProviderAgg`;
        const res = await ApiService.get(queryParam);
        return res.data
    },
    async getTraineeCountDash(query) {
        let queryParam = query ? `/dashboard/traineeCountByDate${query}`
            : `/dashboard/traineeCountByDate`;
        const res = await ApiService.get(queryParam);
        return res.data;
    },
    async getTraineeSummaryDash(query) {
        let queryParam = query ? `/dashboard/traineeSummary${query}`
            : `/dashboard/traineeSummary`;
        const res = await ApiService.get(queryParam);
        return res.data;
    },

    async getAccreditorSummaryDash(query) {
        let queryParam = query ? `/dashboard/accreditor-cpds${query}`
            : `/dashboard/accreditor-cpds`;
        const res = await ApiService.get(queryParam);
        return res.data;
    },

    async getUpcomingRenewalsDash(query) {
        let queryParam = query ? `/dashboard/upcoming-renewals${query}`
            : `/dashboard/upcoming-renewals`;
        const res = await ApiService.get(queryParam);
        return res.data;
    },
    async getCourseSummaryDash(query) {
        let queryParam = query? `/dashboard/courseByCategory${query}` : `/dashboard/courseByCategory`
        const res = await ApiService.get(queryParam);
        return res.data;
    },
    async getTraineeDash(params) {
        let param = params ? `/dashboard/trainees${params}`: `/dashboard/trainees`;
        const res = await ApiService.get(param);
        return res.data;
    },
}
